import React from "react";
import "./SoftwareSkill.scss";
import {skillsSection} from "../../portfolio";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export default function SoftwareSkill() {
  return (
    <div>
      <ul className="dev-icons">
        {skillsSection.softwareSkills.map((logo) => {
          return (
            <OverlayTrigger
              key={logo.skillName}
              placement={"top"}
              overlay={
                <Tooltip id={`tooltip-top`}>
                  <strong>{logo.skillName}</strong>
                </Tooltip>
              }
            >
              <li className="software-skill-inline" name={logo.skillName}>
                {logo.fontAwesomeClassname && (
                  <span
                    className="iconify"
                    data-icon={logo.fontAwesomeClassname}
                    style={logo.style}
                    data-inline="false"
                  ></span>
                )}
                {!logo.fontAwesomeClassname && logo.imageSrc && (
                  <img
                    className="skill-image"
                    style={logo.style}
                    src={require(`../../assets/images/` + logo.imageSrc)}
                    alt={logo.skillName}
                  />
                )}
              </li>
            </OverlayTrigger>
          );
        })}
      </ul>
    </div>
  );
}
